"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRecipeFormValues = void 0;
const enumStrings_1 = require("../../constants/enumStrings");
const transformers_1 = require("../slate/transformers");
const formatTime = ({ type, hr = "0", min = "0" }) => ({
    type,
    value: Math.floor((parseFloat(hr) || 0) * 60 + (parseFloat(min) || 0)),
});
exports.formatRecipeFormValues = (_a) => {
    var { cookbookId: _, croppedBase64Img, times, ingredients } = _a, values = __rest(_a, ["cookbookId", "croppedBase64Img", "times", "ingredients"]);
    const formattedTimes = times.map(formatTime);
    const formattedIngredients = JSON.stringify(ingredients);
    let pictureUrl;
    if (croppedBase64Img === null) {
        pictureUrl = values.pictureUrl || null;
    }
    else if (croppedBase64Img.startsWith("http")) {
        pictureUrl = croppedBase64Img;
    }
    else {
        pictureUrl = enumStrings_1.SEND_UPLOAD_URL;
    }
    return {
        times: formattedTimes,
        ingredients: formattedIngredients,
        name: values.name,
        description: values.description,
        sectionId: values.sectionId,
        source: values.source,
        sourceUrl: values.sourceUrl,
        servings: values.servings,
        youtubeVideoId: values.youtubeVideoId,
        instructions: JSON.stringify(transformers_1.newSlateToOld(values.instructions)),
        pictureUrl,
    };
};
//# sourceMappingURL=formatRecipeFormValues.js.map